import es from 'date-fns/locale/es';
import moment from 'moment';
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { InputText } from 'primereact/inputtext';
import { RadioButton } from 'primereact/radiobutton';
import React, { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import Form from 'react-bootstrap/Form';
import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import * as PROFILE from "../../../constants/profile";
import { SERVICES_REPORTS } from '../../../constants/reports';
import { useAuth } from '../../../hooks/useAuth';

registerLocale('es', es)

function ServicesReport() {

  // #region consts

  const { hasPermission } = useAuth();
  const [dateTypeId, setDateTypeId] = useState(SERVICES_REPORTS.BY_PURCHASE_DATE);  
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [filterId, setFilterId] = useState("0");
  const [filterData, setFilterData] = useState("");
  const [invoiceTypeId, setInvoiceTypeId] = useState("0");
  const [globalFilterValue, setGlobalFilterValue] = useState('');  
  const [report, setReport] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filters, setFilters] = useState({
    'global': { value: null, matchMode: FilterMatchMode.CONTAINS },
    'orderEntityId': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
    'externalOrderId': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
    'driverName': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
    'clientName': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
    'clientId': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
    'phoneNumber': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
    'email': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
    'destiny': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
    'flightNo': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
    'reference': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
    'serviceType': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },    
    'purchaseDateT': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
    'departureTimeT': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
    'vehicleType': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
    'passengerNo': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }] },
    'zone': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
    'price': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
    'paymentType': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
    'agreement': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
    'agreementPrice': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
    'paymentStatus': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
    'operationalStatus': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
    'driverComment': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
    'saleOrigin': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
    'invoiceId': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
    'invoiceNo': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
    'label': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
    'user': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] }
  });

  // #endregion

  // #region methods

  const getServicesReport = (
    dateTypeId,
    start,
    end,
    filterId,
    filterData,
    invoiceTypeId) => {    
    setLoading(true);
    fetch(`${process.env.REACT_APP_API_URL}/order/findOrderByFilter`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        dateTypeId,
        start,
        end,     
        filterId,
        filterData,
        invoiceTypeId
      }),
    }).then(response => response.json()).then(data => {      
      if (data.responseCode === 'OK') {
        const _report = data.responseObject;
        console.log("report", _report);
        setReport(_report);
      }
      setLoading(false);
    });
  }

  const scrollToTop = () => {
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 100);
  }

  const exportAsExcel = () => {
    import('xlsx').then(xlsx => {
      const heading = [[
        'Consecutivo',
        'No. servicio',
        'Conductor',
        'Vehículo',
        'Cliente',
        'ID de Cliente',
        'Teléfono móvil',
        'Correo electrónico',
        'Destino',
        'Vuelo',
        'Origen',
        'Tipo de servicio',
        'Fecha de compra',
        'Fecha de compra (Milisegundos)',
        'Fecha de asignación',
        'Fecha de asignación (Milisegundos)',
        'Tipo de vehículo',
        'Número de pasajeros',
        'Zona',
        'Precio',
        'Forma de pago',
        'Convenio alias',
        'Precio convenio',
        'Estatus de pago',
        'Estatus operativo',
        'Comentarios del conductor',
        'Canal de venta',
        'ID de factura',
        'Folio de factura',
        'Etiqueta',
        'Usuario',
        'Fecha de caja',
        'Estado de caja'
      ]];
      // const worksheet = xlsx.utils.json_to_sheet(report);
      const worksheet = xlsx.utils.json_to_sheet(report, { origin: 'A2', skipHeader: true });
      xlsx.utils.sheet_add_aoa(worksheet, heading, { origin: 'A1' });
      const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
      const excelBuffer = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
      const fileName = 'servicesReport';    
      import('file-saver').then(module => {
        if (module && module.default) {
          let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
          let EXCEL_EXTENSION = '.xlsx';
          const data = new Blob([excelBuffer], {
            type: EXCEL_TYPE
          });
          module.default.saveAs(data, fileName + '-' + new Date().getTime() + EXCEL_EXTENSION);
        }
      });
    });
  };


  // #endregion

  // #region events

  const onGlobalFilterChange = (e) => {
    const value = e.target.value;
    let _filters = { ...filters };
    _filters['global'].value = value;
    setFilters(_filters);
    setGlobalFilterValue(value);
  }

  const onFilterIdSelectChange = (e) => {
    setFilterId(e.target.value);
  };

  const onInvoiceTypeIdSelectChange = (e) => {
    setInvoiceTypeId(e.target.value);
  };

  const onDateTypeIdChange = (e) => {
    setDateTypeId(e.value)
  };

  const onFilterDataChange = (e) => {
    setFilterData(e.target.value);
  };

  const onSearchPress = () => {
    setReport([]);
    getServicesReport(
      parseInt(dateTypeId),
      startDate.valueOf(),
      endDate.valueOf(),
      Number(filterId),
      filterData,
      Number(invoiceTypeId)
    );
  };

  const onExportExcelPress = () => {
    exportAsExcel();
  };

  useEffect(() => {
    scrollToTop();
  }, []);

  // #endregion

  // #region templates

  const filtersTemplate = (
    <>
      <Row>
        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label>
              Tipo de fecha
            </Form.Label>
            <div className="flex flex-wrap gap-3" style={{
              display: "flex"
            }}>
              <div className="flex align-items-center">
                <RadioButton
                  inputId="purchaseDateTypesRadioButton"
                  name="dateTypesRadioButton"
                  value={SERVICES_REPORTS.BY_PURCHASE_DATE}
                  onChange={onDateTypeIdChange}
                  checked={dateTypeId === SERVICES_REPORTS.BY_PURCHASE_DATE}
                />
                <label
                  htmlFor="purchaseDateTypesRadioButton"
                  className="ml-2">
                  &nbsp;Fecha de compra
                </label>
              </div>
              <div className="flex align-items-center">
                <RadioButton
                  inputId="assigmentDateTypeRadioButton"
                  name="dateTypesRadioButton"
                  value={SERVICES_REPORTS.BY_ASSIGMENT_DATE}
                  onChange={onDateTypeIdChange}
                  checked={dateTypeId === SERVICES_REPORTS.BY_ASSIGMENT_DATE}
                />
                <label
                  htmlFor="assigmentDateTypeRadioButton"
                  className="ml-2">
                  &nbsp;Fecha de asignación
                </label>
              </div>
            </div>
          </Form.Group>
        </Col>
        <Col md={3}>
          <Form.Group className="mb-3">
            <Form.Label>
              Fecha inicial
            </Form.Label>
            <DatePicker
              controlId="startDateInput"
              dateFormat="dd/MMM/yyyy"
              selected={startDate}
              onChange={(date) => setStartDate(date)}
              selectsStart
              startDate={startDate}
              endDate={endDate}
              locale="es"
              className="w-100 app_datepicker" />
          </Form.Group>
        </Col>
        <Col md={3}>
          <Form.Group className="mb-3">
            <Form.Label>
              Fecha final
            </Form.Label>
            <DatePicker
              controlId="endDateInput"
              dateFormat="dd/MMM/yyyy"
              selected={endDate}
              onChange={(date) => setEndDate(date)}
              selectsEnd
              startDate={startDate}
              endDate={endDate}
              minDate={startDate}
              locale="es"
              className="w-100 app_datepicker" />
          </Form.Group>
        </Col>
      </Row>
      <Row>
        <Col md={4}>
          <Form.Group className="mb-3">
            <Form.Label>
              Estado facturación
            </Form.Label>
            <Form.Select
              aria-label="Default select example"
              value={invoiceTypeId}
              onChange={onInvoiceTypeIdSelectChange}>
              <option value="0">Todos</option>
              <option value="1">Facturado</option>
              <option value="2">Sin facturar</option>
              <option value="3">Cancelada</option>
            </Form.Select>
          </Form.Group>
        </Col>
        <Col md={4}>
          <Form.Group className="mb-3">
            <Form.Label>
              Filtrar por
            </Form.Label>
            <Form.Select
              aria-label="Default select example"
              value={filterId}
              onChange={onFilterIdSelectChange}>
              <option value="0">Todos</option>
              <option value="1">Conductor</option>
              <option value="2">Cliente</option>
              <option value="3">No. Servicio</option>
              <option value="4">No. Unidad</option>
            </Form.Select>
          </Form.Group>
        </Col>
        <Col md={4}>
          <Form.Group className="mb-3">
            <Form.Label>&nbsp;</Form.Label>
            <Form.Control
              type="text"
              placeholder="Filtrar por"
              value={filterData}
              onChange={onFilterDataChange} />
          </Form.Group>
        </Col>
      </Row>
      <Row>
        <Col>
          <Button
            type="button"
            icon="pi pi-search"
            onClick={onSearchPress}
            className="p-button-raised p-button-sm p-button-primary"
            label='Buscar' />
        </Col>
      </Row>
    </>
  );

  const reportHeaderTemplate = (
    <>      
      <Row>
        <Col>
          <span className="p-input-icon-left">
            <i className="pi pi-filter" />
            <InputText
              value={globalFilterValue}
              onChange={onGlobalFilterChange}
              placeholder="Filtrar"
              className='p-inputtext-sm'               
            />
          </span>
        </Col>
        <Col>
          {
            hasPermission(PROFILE.PERMISSIONS.DOWNLOAD_REPORTS) && (
              <Button
                type="button"
                icon="pi pi-file-excel"
                onClick={onExportExcelPress}
                className="p-button-raised p-button-sm p-button-success mr-2 float-end"
                data-pr-tooltip="XLS"
                label='Exportar'                 
              />   
            )
          }
        </Col>
      </Row>
    </>
  );

  const purchaseDateTTemplate = (row) => {
    const purchaseDateT = row.purchaseDateT;
    if (purchaseDateT > 0) {
      const purchaseDateTMoment = moment(purchaseDateT);
      return (
        <span>{purchaseDateTMoment.format("DD/MM/YYYY hh:mm:ss a")}</span>
      );
    } else { 
      return <></>;
    }    
  }

  const departureTimeTTemplate = (row) => {
    const departureTimeT = row.departureTimeT;
    if (departureTimeT > 0) {
      const departureTimeTMoment = moment(departureTimeT);
      return (
        <span>{departureTimeTMoment.format("DD/MM/YYYY hh:mm:ss a")}</span>
      );
    } else { 
      return <></>;
    }    
  }  

  const cashierModifiedDateTTemplate = (row) => {
    const cashierModifiedDateT = row.cashierModifiedDateT;
    if (cashierModifiedDateT > 0) {
      const cashierModifiedDateTMoment = moment(cashierModifiedDateT);
      return (
        <span>{cashierModifiedDateTMoment.format("DD/MM/YYYY hh:mm:ss a")}</span>
      );
    } else {
      return <></>;
    }
  };  

  const resultTemplate = (
    <>
      <div>
        <div className="card">
          <DataTable
            value={report}
            paginator
            className="p-datatable-customers"
            showGridlines
            stripedRows
            header={reportHeaderTemplate}
            rows={50}
            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
            rowsPerPageOptions={[10, 25, 50]}            
            filters={filters} filterDisplay="menu"
            loading={loading}
            responsiveLayout="scroll"            
            globalFilterFields={[
              'orderEntityId',
              'externalOrderId',
              'driverName',
              'vehicleNo',
              'clientName',
              'clientId',
              'phoneNumber',
              'email',
              'destiny',
              'flightNo',
              'reference',
              'serviceType',              
              'purchaseTimeT',
              'departureTimeT',
              'vehicleType',
              'passengerNo',
              'zone',
              'price',
              'paymentType',
              'agreement',
              'agreementPrice',
              'paymentStatus',
              'operationalStatus',
              'driverComment',
              'saleOrigin',
              'invoiceId',
              'invoiceNo',
              'label',
              'user',
              'cashierModifiedDateT',
              'cashierDescription'
            ]}
            emptyMessage="No customers found."
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries">
            <Column field="orderEntityId" header="Consecutivo" sortable filter filterPlaceholder="Buscar por Consecutivo" className='app-w-150-px text-end' />
            <Column field="externalOrderId" header="No. servicio" sortable filter filterPlaceholder="Buscar por No. servicio" className='app-w-250-px text-end' />
            <Column field="driverName" header="Conductor" sortable filter filterPlaceholder="Buscar por Conductor" className='app-w-250-px text-start' />
            <Column field="vehicleNo" header="Vehículo" sortable filter filterPlaceholder="Buscar por Vehículo" className='app-w-100-px text-start' />            
            <Column field="clientName" header="Cliente" sortable filter filterPlaceholder="Buscar por Cliente" className='app-w-250-px text-start' />            
            <Column field="clientId" header="ID de Cliente" sortable filter filterPlaceholder="Buscar por ID de Cliente" className='app-w-100-px text-end' />
            <Column field="phoneNumber" header="Teléfono móvil" sortable filter filterPlaceholder="Buscar por Teléfono móvil" className='app-w-100-px text-start' />
            <Column field="email" header="Correo electrónico" sortable filter filterPlaceholder="Buscar por Correo electrónico" className='app-w-300-px text-start' />
            <Column field="destiny" header="Destino" sortable filter filterPlaceholder="Buscar por Destino" className='app-w-500-px text-start' />
            <Column field="flightNo" header="Vuelo" sortable filter filterPlaceholder="Buscar por Vuelo" className='app-w-150-px text-start' />
            <Column field="reference" header="Origen" sortable filter filterPlaceholder="Buscar por Origen" className='app-w-500-px text-start' />
            <Column field="serviceType" header="Tipo de servicio" sortable filter filterPlaceholder="Buscar por Tipo de servicio" className='app-w-150-px text-start' />            
            <Column field="purchaseTimeT" header="Fecha de compra" sortable filter filterPlaceholder="Buscar por Fecha de compra" className='app-w-300-px text-start' body={purchaseDateTTemplate} />
            <Column field="departureTimeT" header="Fecha de asignación" sortable filter filterPlaceholder="Buscar por Fecha de asignación" className='app-w-300-px text-start' body={departureTimeTTemplate} />
            <Column field="vehicleType" header="Tipo de vehículo" sortable filter filterPlaceholder="Buscar por Tipo de vehículo" className='app-w-200-px text-start' />
            <Column field="passengerNo" header="Número de pasajeros" sortable filter filterPlaceholder="Buscar por Número de pasajeros" className='app-w-200-px text-end' />
            <Column field="zone" header="Zona" sortable filter filterPlaceholder="Buscar por Zona" className='app-w-200-px text-start' />
            <Column field="price" header="Precio" sortable filter filterPlaceholder="Buscar por Precio" className='app-w-150-px text-end' />
            <Column field="paymentType" header="Forma de pago" sortable filter filterPlaceholder="Buscar por Forma de pago" className='app-w-250-px text-start' />
            <Column field="agreement" header="Convenio alias" sortable filter filterPlaceholder="Buscar por Convenio alias" className='app-w-150-px text-start' />
            <Column field="agreementPrice" header="Precio convenio" sortable filter filterPlaceholder="Buscar por Precio convenio" className='app-w-150-px text-end' />
            <Column field="paymentStatus" header="Estatus de pago" sortable filter filterPlaceholder="Buscar por Estatus de pago" className='app-w-200-px text-start' />
            <Column field="operationalStatus" header="Estatus operativo" sortable filter filterPlaceholder="Buscar por Estatus operativo" className='app-w-150-px text-start' />
            <Column field="driverComment" header="Comentarios del conductor" sortable filter filterPlaceholder="Buscar por Comentarios del conductor" className='app-w-500-px text-start' />
            <Column field="saleOrigin" header="Canal de venta" sortable filter filterPlaceholder="Buscar por Canal de venta" className='app-w-250-px text-start' />
            <Column field="invoiceId" header="ID de factura" sortable filter filterPlaceholder="Buscar por ID de factura" className='app-w-200-px text-start' />
            <Column field="invoiceNo" header="Folio de factura" sortable filter filterPlaceholder="Buscar por Folio de factura" className='app-w-250-px text-end' />
            <Column field="label" header="Etiqueta" sortable filter filterPlaceholder="Buscar por Etiqueta" className='app-w-200-px text-start' />
            <Column field="user" header="Usuario" sortable filter filterPlaceholder="Buscar por Usuario" className='app-w-200-px text-start' />
            <Column field="cashierModifiedDateT" header="Fecha de caja" sortable filter filterPlaceholder="Buscar por Fecha de caja" className='app-w-300-px text-start' body={cashierModifiedDateTTemplate} />
            <Column field="cashierDescription" header="Estado de caja" sortable filter filterPlaceholder="Buscar por Estado de caja" className='app-w-200-px text-start' />
          </DataTable>
        </div>
      </div>
    </>
  );

  const reportTemplate = (
    <>
      <article>
        <Row>
          <Col>
            <h1 className='app-font'>
              Reporte de Servicios
            </h1>
          </Col>
        </Row>
        <Row>
          <Col>
            {filtersTemplate}
          </Col>
        </Row>
        <Row className='pt-2'>
          <Col>
            {resultTemplate}
          </Col>
        </Row>
      </article>
    </>
  );

  // #endregion

  return (
    <>
      {reportTemplate}
    </>
  );
}

export default ServicesReport;